import React from 'react';
import CircleCheckedFilled from '@material-ui/icons/CheckCircleSharp';
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import Checkbox from '@material-ui/core/Checkbox';

class EquipmentCard extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      value: '',
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        <button onClick={() => this.props.emit()} className={`w-100 checkbox-btn ${this.props.checked ? 'checked' : ''}`}>
          <Checkbox
            icon={<CircleUnchecked/>}
            checkedIcon={<CircleCheckedFilled/>}
            onChange={() => this.props.emit()}
            checked={this.props.checked}
          />
          <span>{this.props.title}</span>
          {this.props.children}
        </button>
      </div>
    );
  }
}

export default (EquipmentCard);
